export default {"src":"/_next/static/media/cover4.1a80c4aa.svg","height":560,"width":1440};